import React from "react"
import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import Category from "@/components/Menu/Desktop/Category"
import WWDLink from "@/components/Menu/Shared/WWDLink"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { useIsDesktop } from "@/hooks/useDevice"

export const Container = styled(GridContainer)`
	//grid-gap: unset;
	position: relative;
	row-gap: unset;
	//height: fit-content;

	&.negative-margin-x {
		margin-right: calc(var(--paddingX) * -1) !important;
		margin-left: calc(var(--paddingX) * -1) !important;

		> div {
			padding-right: calc(var(--paddingX));
			padding-left: calc(var(--paddingX));
			border-top: solid 2px ${({ theme }) => theme.colors.platinum};
		}
	}

	.section-wrapper {
		> div.category:last-of-type {
			width: calc(100% + var(--paddingX) + var(--grid-gap));
		}
	}

	&.margin-bottom {
		margin-bottom: ${getCssSizeValue(52, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		height: 100%;
	}
`

const WWDHeader = styled(WWDLink)`
	--translate: ${getCssSizeValue(50, BREAKPOINTS.DESKTOP)};
	position: absolute !important;
	left: 0;
	transform: translateY(calc(var(--translate) * -1));
	font-weight: ${({ theme }) => theme.fontWeight.medium} !important;
	color: ${({ theme }) => theme.colors.chineseViolet} !important;
`

const Section = ({ data, down = false }) => {
	const isDesktop = useIsDesktop(false)
	const desktopWidth = down ? 4 : 12
	const tabletWidth = down ? 2 : 6
	const grid = !isDesktop ? tabletWidth : desktopWidth
	const items = data || []
	return (
		<Container className={`no-margin section-wrapper col-tablet-8 col-desktop-16 height `}>
			{items.map((item, index) => {
				if (!item) return
				if (Array.isArray(item)) {
					return (
						<Container
							key={item?.id || index}
							className={`no-margin grid-${grid} col-tablet-${tabletWidth} col-desktop-${desktopWidth}`}
						>
							{item.map((nestedItem, nestedIndex) => {
								return (
									<Category
										key={nestedItem?.id || nestedIndex}
										data={nestedItem}
										indent={index !== 0}
										className={`${down ? "down" : "up"} `}
									>
										{!down && nestedIndex === 1 && isDesktop && <WWDHeader noHoverEffect />}
									</Category>
								)
							})}
						</Container>
					)
				} else {
					return <Category key={item?.id || index} data={item} indent={index !== 0} className={`${down ? "down" : "up"}`} />
				}
			})}
		</Container>
	)
}
export default Section
